/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboStockManagementBadRequestResponse,
  BboStockManagementFailureResponseResponse,
  BboStockManagementForbiddenResponse,
  BboStockManagementNoContentResponse,
  BboStockManagementUnauthorizedResponse,
  StockCountBody,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get stock count details at any level
 * @summary This endpoint will update resume suspend stock count  status to InProgress
 */
export const getStockCountForAl = (accountingLocationID: string, signal?: AbortSignal) => {
  return customInstance<StockCountBody | BboStockManagementNoContentResponse>({
    url: `/bm-stock-management-service/v1/stock-count/resume/${accountingLocationID}`,
    method: 'get',
    signal,
  });
};

export const getGetStockCountForAlQueryKey = (accountingLocationID: string) => {
  return [`/bm-stock-management-service/v1/stock-count/resume/${accountingLocationID}`] as const;
};

export const getGetStockCountForAlQueryOptions = <
  TData = Awaited<ReturnType<typeof getStockCountForAl>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCountForAl>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetStockCountForAlQueryKey(accountingLocationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getStockCountForAl>>> = ({ signal }) =>
    getStockCountForAl(accountingLocationID, signal);

  return { queryKey, queryFn, enabled: !!accountingLocationID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getStockCountForAl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetStockCountForAlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getStockCountForAl>>
>;
export type GetStockCountForAlQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary This endpoint will update resume suspend stock count  status to InProgress
 */
export const useGetStockCountForAl = <
  TData = Awaited<ReturnType<typeof getStockCountForAl>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getStockCountForAl>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetStockCountForAlQueryOptions(accountingLocationID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Get stock count details at any level
 * @summary This endpoint will get the suspended stock count details
 */
export const getSuspendStockCountAl = (accountingLocationID: string, signal?: AbortSignal) => {
  return customInstance<StockCountBody | BboStockManagementNoContentResponse>({
    url: `/bm-stock-management-service/v1/stock-count/suspend/${accountingLocationID}`,
    method: 'get',
    signal,
  });
};

export const getGetSuspendStockCountAlQueryKey = (accountingLocationID: string) => {
  return [`/bm-stock-management-service/v1/stock-count/suspend/${accountingLocationID}`] as const;
};

export const getGetSuspendStockCountAlQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuspendStockCountAl>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuspendStockCountAl>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetSuspendStockCountAlQueryKey(accountingLocationID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuspendStockCountAl>>> = ({ signal }) =>
    getSuspendStockCountAl(accountingLocationID, signal);

  return { queryKey, queryFn, enabled: !!accountingLocationID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuspendStockCountAl>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSuspendStockCountAlQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuspendStockCountAl>>
>;
export type GetSuspendStockCountAlQueryError = ErrorType<
  | BboStockManagementBadRequestResponse
  | BboStockManagementUnauthorizedResponse
  | BboStockManagementForbiddenResponse
  | BboStockManagementFailureResponseResponse
>;

/**
 * @summary This endpoint will get the suspended stock count details
 */
export const useGetSuspendStockCountAl = <
  TData = Awaited<ReturnType<typeof getSuspendStockCountAl>>,
  TError = ErrorType<
    | BboStockManagementBadRequestResponse
    | BboStockManagementUnauthorizedResponse
    | BboStockManagementForbiddenResponse
    | BboStockManagementFailureResponseResponse
  >,
>(
  accountingLocationID: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSuspendStockCountAl>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetSuspendStockCountAlQueryOptions(accountingLocationID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
